import { z } from 'zod'

import { AddressType } from './member.types'

// TODO: This file is temporary until BE devs generate these types for us via a types npm package

const AddressSchema = z.object({
  line1: z.string(),
  city: z.string(),
  postcode: z.string(),
  country: z.string(),
  type: z.enum(AddressType),
})

export const MemberSchema = z.object({
  id: z.number(),
  mvneId: z.string(),
  title: z.string(),
  originalMemberName: z.string(),
  memberName: z.string(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  alternativePhoneNumber: z.string(),
  hasActiveSim: z.boolean(),
  tcVersion: z.number(),
  birthDate: z.string(),
  memberSince: z.string(),
  notifyPromotions: z.boolean(),
  marketingOptIn: z.boolean(),
  marketingPrefsServicePlus: z.boolean(),
  marketingPrefsProducts: z.boolean(),
  marketingPrefs3PartiesInternal: z.boolean(),
  marketingPrefs3PartiesExternal: z.boolean(),
  memberNameConfirmed: z.boolean(),
  addresses: z.array(AddressSchema),
  hasMfa: z.boolean(),
  marketingPrefsPostal: z.boolean(),
  lastLoginTime: z.string(),
})
